<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
    <loading-spinner v-if="isLoading" />
  </div>
</template>

<script>
import { EventBus } from "@/utils/event-bus";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "app",
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      defaultLayout: "default",
    };
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.meta.title) {
          document.title = `INFRASEL CMS - ${this.$route.meta.title}`;
        } else {
          document.title = "INFRASEL CMS";
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    layout() {
      let layout = `${this.$route.meta.layout || this.defaultLayout}-layout`;
      return layout;
    },
  },
  methods: {
    toggleLoadingSpinner(e) {
      this.isLoading = e;
    },
  },
  mounted() {
    EventBus.$on("toggleLoadingSpinner", this.toggleLoadingSpinner);
  },
  beforeDestroy() {
    EventBus.$off("toggleLoadingSpinner");
  },
};
</script>